import { render, staticRenderFns } from "./UserListField.vue?vue&type=template&id=49c46b80&scoped=true"
import script from "./UserListField.vue?vue&type=script&lang=js"
export * from "./UserListField.vue?vue&type=script&lang=js"
import style0 from "./UserListField.vue?vue&type=style&index=0&id=49c46b80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c46b80",
  null
  
)

export default component.exports